/* DEVELOPER NOTE:

  Find and replace this string, '// DevComment: ' with '' if you want get some
  sweets debug messages. But you have to revert the changes for two reasons:
  1. We want to keep those lines in order to debug again.
  2. No production enviroment should have console o other test committed to
     production.

  Also, help us improve our debugging code. Thanks
*/
!function (global) {
    'use strict';

    var previousFiltersSearch = global.FiltersSearch;

    function FiltersSearch(options) {
        var options = options || {};
        var currentCity = '';
        var preventCityRender = false;
        var $conf;
        var $modal;
        var $bar;
        var bhCities;
        var $taCities;
        var $selectSalary;
        var $selectCandidateType;
        var $checkboxSalary;
        var $checkboxCandidateType;
        var $selectDatePublished;
        var $radioDatePublished;
        var $selectArea;
        var callback;
        var selectedFilters;

        function init() {
            // DevComment: var t0;
            // DevComment: var t1;
            // DevComment: t0 = performance.now();
            // DevComment: console.group('Module Initialization: Filters');
            $modal = options.$modal;
            $bar = options.$bar;
            $conf = options.$conf;
            selectedFilters = options.selectedFilters;

            // TODO: Check that callback is not undefined and it is a function
            callback = options.callback;

            bindingSelects();
            bindingCities();
            bindingDatePublished();
            bindingAreas();

            // DevComment: console.groupEnd();
            // DevComment: t1 = performance.now();
            // DevComment: console.warn('Filters Initialization executed in ' + (t1 - t0) + ' ms.');
        }

        function bindingSelects() {
            $selectSalary = $modal.find('.js-filter-salary');
            $checkboxSalary = $bar.find('.js-filter-salary');
            $checkboxCandidateType = $bar.find('.js-filter-candidate-type');
            $selectCandidateType = $modal.find('.js-filter-candidate-type');

             // DevComment: console.log('Binding: Salary Select');
            $selectSalary.on('change', 'input[type="checkbox"]', function (event) {
                var checkedValues = [];

                $selectSalary.find(':checked').each(function (i, element) {
                    checkedValues.push(parseInt(element.value));
                });

                // DevComment: console.log('Salaries Checked: ', checkedValues);
                callback('salaryInfo', checkedValues);
                closeModal();
            });

            // DevComment: console.log('Binding: Salary Checkbox');
            $checkboxSalary.on('change', 'input[type="checkbox"]', function (event) {
                var checkedValues = [];

                $checkboxSalary.find(':checked').each(function (i, element) {
                    checkedValues.push(parseInt(element.value));
                });

                // DevComment: console.log('Salaries Checked: ', checkedValues);
                callback('salaryInfo', checkedValues);
                closeModal();
            });

            $selectCandidateType.on('change', function () {
                var selectedValue = [parseInt(this.value)];

                callback('educationStatusInfo', selectedValue);

                closeModal();
            });

            $checkboxCandidateType.on('change', 'input[type="checkbox"]', function () {
                var checkedValues = [];

                $checkboxCandidateType.find(':checked').each(function (i, element) {
                    checkedValues.push(parseInt(element.value));
                });

                callback('educationStatusInfo', checkedValues);
                closeModal();
            });
        }

        function bindingCities() {
            var notFoundCopy;

            notFoundCopy = $conf.data('resources').taCitiesNotFound;

            $taCities = $modal.find('.js-filter-cities')
                .add($bar.find('.js-filter-cities'));

            // Setting Init params
            // TODO: Move this var declaration to the init of the scope
            var initCityName = options.$conf.data('cities-val')
                .filter(function (e) {
                    return parseInt(e.id) === selectedFilters.city;
                });
            currentCity = initCityName.length > 0 ? initCityName[0].name : '';

            if (currentCity === 'Todas las ciudades' || currentCity === 'Todos los cantones') {
                localStorage.setItem("CitiesV2", JSON.stringify(options.$conf.data('cities-val')));
            }

            bhCities = new Bloodhound({
                datumTokenizer: function (data) {
                    return Bloodhound.tokenizers.whitespace(data.name);
                },
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                local: JSON.parse(localStorage.getItem("CitiesV2"))
            });

            $taCities.typeahead(
                {
                    minLength: 0,
                    highlight: true
                },
                {
                    name: 'search',
                    displayKey: 'name',
                    limit: 100,
                    source: function (q, sync) {
                        if (q === '') {
                            sync(bhCities.index.all());
                        }
                        else {
                            bhCities.search(q, sync);
                        }
                    },
                    templates: {
                        notFound: '<div class="tt-suggestion tt-notfound ">' + notFoundCopy + '</div>'
                    }
                }
            );

            // TODO: Check data for cities with duplicate keys for id property
            $taCities.typeahead('val', currentCity);

            // DevComment: console.log('Binding: Cities Typeahead');
            $taCities
                .on('typeahead:select', function (event, suggestion) {
                    // DevComment: console.log('City Selected: ', suggestion);
                    preventCityRender = true;

                    currentCity = suggestion.name;

                    $taCities.blur();

                    callback('city', suggestion.id);
                    closeModal();
                })
                .on('typeahead:active', function () {
                    $taCities.typeahead('val', '');
                })
                .on('blur', function () {
                    $taCities.typeahead('val', currentCity);
                });
        }

        function bindingDatePublished() {
            $selectDatePublished = $modal.find('.js-filter-date-published');
            $radioDatePublished = $bar.find('.js-filter-date-published');

            // DevComment: console.log('Binding: Date Published Select');
            $selectDatePublished.on('change', function (event) {
                // DevComment: console.log('Date Published Selected: ', this.value);
                callback('publishDate', this.value);
                closeModal();
            });

            // DevComment: console.log('Binding: Date Published Radio');
            $radioDatePublished.on('change', 'input[type="radio"]', function (event) {
                // DevComment: console.log('Date Published Selected: ', this.value);
                callback('publishDate', this.value);

                closeModal();
            });
        }

        function bindingAreas() {
            $selectArea = $modal.find('.js-filter-sector')
                .add($bar.find('.js-filter-sector'));

            // DevComment: console.log('Binding: Area Selects');
            $selectArea.on('change', function () {
                // DevComment: console.log('Area Selected: ', parseInt(this.value));
                callback('area', parseInt(this.value));
                closeModal();
            });
        }

        function closeModal() {
            $modal.modal('hide');
        }

        function updateFilters(filters, currentParams) {
            renderSalaries(filters.salaries, currentParams);

            var listado = JSON.parse(localStorage.getItem("CitiesV2"));

            // Updating City Filter
            currentCity = getSelectedCityName(currentParams);
            $taCities.typeahead('val', currentCity);
            if (preventCityRender) {
                preventCityRender = false;
            }
            else {
                renderCities(listado, currentParams.city);
            }

            renderDatePublished(filters.publishDates, currentParams.publishDate);
            renderAreas(filters.areas, currentParams.area);
        }

        function renderSalaries(data, currentParams) {
            var currentId = currentParams.salaryInfo;
            var fragment;
            var $formGroup;

            $formGroup = $selectSalary.closest('.form-group')
                .add($checkboxSalary.closest('.form-group'));

            if (data.length > 0) {
                // Show form-group again
                $formGroup.show();               

                // Build desktop
                fragment = buildCheckBoxes(data);
                $checkboxSalary.empty().append(fragment);

                $checkboxSalary.find(':checkbox').each(function (i, element) {
                    var isChecked = $.inArray(parseInt(element.value), currentId) > -1;
                    var label = $(element).parents('.checkbox').find('label');
                    var badge = $(element).parents('.checkbox').find('.badge');

                    if (isChecked) {
                        element.checked = true;
                        $(label).removeClass('filter-selected-item').addClass('filter-selected-item');
                        $(badge).removeClass('filter-selected-item').addClass('filter-selected-item');
                    }

                    if (currentId.length > 0) {
                        badge.text('');
                    }
                });
                /*
                  fragment = buildRadios(data, currentId, 'salary', 'SalaryInfo1', true);
                  $checkboxSalary.empty().append(fragment);
                */
            } else {
                $formGroup.hide();
            }
        }

        function renderCities(data, currentId) {
            var $formGroup;

            $formGroup = $taCities.closest('.form-group');

            if (data.length > 0) {
                // Show form-group again
                $formGroup.show();

                bhCities.clear();
                bhCities.local = data;
                bhCities.initialize(true);
            } else {
                $formGroup.hide();
            }
        }

        function renderDatePublished(data, currentId) {
            var fragment;

            fragment = buildSelectOptions(data);
            $selectDatePublished.empty().append(fragment).val(currentId);

            fragment = buildRadios(data, currentId, 'publishDate', 'PublishDatesInfo1', false);
            $radioDatePublished.empty().append(fragment);
        }

        function renderAreas(data, currentId) {
            var fragment;
            var $formGroup;

            $formGroup = $selectArea.closest('.form-group');

            if (data.length > 0) {
                // Show form-group again
                $formGroup.show();

                fragment = buildSelectOptions(data);
                $selectArea.empty().append(fragment).val(currentId);
            } else {
                $formGroup.hide();
            }
        }

        function buildCheckBoxes(data) {
            var optionsFrag = document.createDocumentFragment();
            var i;
            var div;
            var label;
            var input;
            var text;
            var span;
            var id;

            for (i = 0; i < data.length; i++) {
                div = document.createElement('div');
                span = document.createElement('span');
                input = document.createElement('input');
                label = document.createElement('label');

                text = document.createTextNode(data[i].name);
                id = 'salary' + i;

                input.type = 'checkbox';
                input.id = id;
                input.name = 'SalaryInfo1';
                input.value = data[i].id;

                span.textContent = data[i].count;
                span.className = 'badge pull-right';

                label.htmlFor = id;
                label.appendChild(input);
                label.appendChild(text);

                div.className = 'checkbox';
                div.appendChild(label);
                div.appendChild(span);

                optionsFrag.appendChild(div);
            }

            return optionsFrag;
        }

        function buildSelectOptions(data) {
            var optionsFrag = document.createDocumentFragment();
            var i;
            var option;

            for (i = 0; i < data.length; i++) {
                option = document.createElement('option');
                option.text = data[i].name;
                option.value = data[i].id;

                optionsFrag.appendChild(option);
            }

            return optionsFrag;
        }

        function buildRadios(data, currentVal, idString, nameString, badge) {
            var radiosFrag = document.createDocumentFragment();
            var i;
            var id;
            var text;
            var div;
            var input;
            var label;
            var span;

            for (i = 0; i < data.length; i++) {
                div = document.createElement('div');
                span = document.createElement('span');
                input = document.createElement('input');
                label = document.createElement('label');
                text = document.createTextNode(data[i].name);
                id = idString + i;


                input.type = 'radio';
                input.id = id;
                input.name = nameString;
                input.value = data[i].id;

                if (input.value == currentVal) {
                    input.checked = true;
                }

                span.textContent = data[i].count;
                span.className = 'badge pull-right';

                label.htmlFor = id;
                label.appendChild(input);
                label.appendChild(text);

                div.className = 'radio';
                div.appendChild(label);
                if (badge) {
                    div.appendChild(span);
                }

                radiosFrag.appendChild(div);
            }

            return radiosFrag;
        }

        function getSelectedCityName(filters) {
            var listado = JSON.parse(localStorage.getItem("CitiesV2"));
            var selectedCity = listado
                .filter(function (e) {
                    return e.id == filters.city;
                });
            return selectedCity.length > 0 ? selectedCity[0].name : '';
        }

        init();

        return {
            update: updateFilters
        }
    }

    FiltersSearch.noConflict = function noConflict() {
        global.FiltersSearch = previousFiltersSearch;
        return FiltersSearch;
    };

    global.FiltersSearch = FiltersSearch;
}(this);
